import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

type PostRoutesRequest = { from: string, to: string }[];
type DeleteRoutesRequest = {id: string}[];

export const routesService = {
    dashboardRoutes: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.dashboardRoutes);
    },
    getRoutes: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getRoutes);
    },
    addRoutes: async (data: PostRoutesRequest): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.postRoutes, data);
    },
    deleteRoutes: async (data: DeleteRoutesRequest): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.deleteRoutes, data);
    },
}